import React from "react";

import { AsyncSelect, IAsyncSelectProps } from "@amphore-dev/amphore-lib";
import { t } from "i18next";

import CompaniesService from "@/services/CompaniesService";

import { renderSwatchOption } from "@/utils/USelect";
import { cn } from "@/utils/cn";

import { TCompany } from "@/types";

export const CompanySelect: React.FC<Partial<IAsyncSelectProps<TCompany>>> = (
	props
) => {
	const fetchOptions = () =>
		CompaniesService.fetchAll().then((response) => {
			if (response.length === 1) {
				props.onChange?.(response[0]);
			}

			return response.map((company) => ({
				value: company,
				label: company.name,
			}));
		});

	return (
		<AsyncSelect
			loadOptions={fetchOptions}
			isClearable={true}
			getOptionValue={(company) => company.id}
			renderOption={renderSwatchOption<TCompany>(true)}
			{...props}
			label={props.label || t("company.label")}
			placeholder={props.placeholder || t("company.select")}
			className={cn(["w-full", props.className])}
		/>
	);
};
